/* eslint-disable no-magic-numbers */

/**
 * Returns day name for given date
 */
export const getDayName = (date: Date, format: 'long' | 'short' | 'narrow' = 'long') => {
  return date.toLocaleString('en-US', {
    weekday: format
  });
};

/**
 * Returns month name for month number
 * @param monthNumber - Month number (needs to be 1-12) to get the name for
 */
export const getMonthName = (monthNumber: number) => {
  const date = new Date(2024, monthNumber - 1, 1);

  return date.toLocaleString('en-US', {
    month: 'long'
  });
};
